import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";

import { SimpleCustomer } from "../../../../../../dtos/customer";
import { AjaxResult } from "../../../../../../enums/ajaxResult";
import { useApi } from "../../../../../useApi";

import { useEffectiveOrgId } from "./useEffectiveOrgId";

export function useCustomers(
    boxOrgId: number | undefined,
    boxSiteId: number | undefined,
    enabled: boolean,
): {
    customers: SimpleCustomer[];
    showOrgCustomers: boolean,
    setShowOrgCustomers: (value: boolean) => void,
    load: () => void;
    loading: boolean;
} {
    const { enqueueSnackbar } = useSnackbar();
    const { customerApi } = useApi();
    const [showOrgCustomers, setShowOrgCustomers] = useState(false);
    const [customers, setCustomers] = useState<SimpleCustomer[]>([]);
    const [loading, setLoading] = useState(false);
    const orgId = useEffectiveOrgId(boxOrgId)

    const load = useCallback(() => {
        if (!enabled) return;
        setCustomers([]);
        setLoading(true);
        if (showOrgCustomers) {
            customerApi.listCustomersForOrg(orgId).then((r) => {
                if (r.result === AjaxResult.Success && r.data) {
                    setCustomers(r.data);
                } else {
                    enqueueSnackbar(
                        "Failed to get list of customers for organization",
                        { variant: "error" },
                    );
                }
                setLoading(false);
            });
        } else if (boxSiteId) {
            customerApi.listCustomersForSite(orgId, boxSiteId).then((r) => {
                if (r.result === AjaxResult.Success && r.data) {
                    setCustomers(r.data);
                } else {
                    enqueueSnackbar(
                        "Failed to get list of customers for site",
                        { variant: "error" },
                    );
                }
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }, [boxSiteId, orgId, showOrgCustomers, customerApi, enqueueSnackbar, enabled]);

    useEffect(() => {
        load();
    }, [load]);

    useEffect(() => {
        if (!enabled) setShowOrgCustomers(false);
    }, [enabled]);

    return {
        customers,
        showOrgCustomers,
        setShowOrgCustomers,
        load,
        loading,
    };
}
